import { Component } from 'react';
import classNames from 'clsx';
import { LANDING_SUGGEST_SEARCH_V2 } from '../../constants/localizations/landing';
import cssVariables from '../../styles/variables';
import SearchBar from '../search/Searchbar';
import searchCss from '../search/search.module.scss';
import commonCss from '../../styles/common.module.scss';
import {
  ERROR_TITLE,
  ERROR_TEXT,
} from '/src/common/constants/localizations/error';
import { LocationAndLocalizationContext } from '../../providers/LocationAndLocalizationProvider';
import css from './errorPage.module.scss';

class ErrorPage extends Component {
  static contextType = LocationAndLocalizationContext;

  render() {
    const { getLocalizedText } = this.context;
    const searchIconProps = {
      width: '26px',
      height: '26px',
      fill: cssVariables['--secondary-color-5'],
    };

    return (
      <div className={commonCss.contentContainer}>
        <div
          id="searchBarContainer"
          data-testid="searchBarContainer"
          className={classNames(
            css.searchBarContainer,
            searchCss.searchBarContainer,
          )}
        >
          <SearchBar
            iconContainerClassName={searchCss.searchIconContainer}
            placeholder={getLocalizedText(LANDING_SUGGEST_SEARCH_V2)}
            iconProps={searchIconProps}
          />
        </div>
        <div
          id="errorTextAndVideoContainer"
          data-testid="errorTextAndVideoContainer"
          className={css.errorTextAndVideoContainer}
        >
          <div className={css.errorVideoImage}>
            <img
              src="/assets/img/error/signOff.png"
              className={css.image1}
              role="presentation"
            />
            <img
              src="/assets/img/error/signOn.png"
              className={css.image2}
              role="presentation"
            />
            <img
              src="/assets/img/error/textLight.png"
              className={css.image3}
              role="presentation"
            />
          </div>

          <div
            id="errorTextContainer"
            data-testid="errorTextContainer"
            className={css.errorTextContainer}
          >
            <h1 data-testid="errorTextTitle" className={css.errorTextTitle}>
              {getLocalizedText(ERROR_TITLE)}
            </h1>
            <h3 data-testid="errorTextSubtitle" className={css.errorText}>
              {getLocalizedText(ERROR_TEXT)}
            </h3>
          </div>
        </div>
      </div>
    );
  }
}

export default ErrorPage;
